import { GroupId } from '@sr/types';
import { useEffect } from 'react';
import { Link as TUILink } from 'theme-ui';
import { getGroupDescription } from './group-utils';
import trackEvent from 'utils/analytics';
import { useUser } from 'v1/hooks/use-user';
import { Box, Link } from 'v1/ui';

const linkStyles = {
  color: 'black',
  borderRadius: 999,
  py: '6px',
  width: 150,
  justifyContent: 'center',
  fontSize: 13,
  mb: 2,
  fontWeight: 600,
  transition: 'opacity 250ms ease-in-out',
  ':hover': {
    opacity: 0.9,
  },
};

export default function Upsell({ groupId }: { groupId: GroupId }) {
  const user = useUser();
  const groupDescription = getGroupDescription(groupId);
  const shouldCreateAccount = user && user.isAnonymous;

  useEffect(() => {
    trackEvent.reviewUpsellViewed({ groupId });
  }, [groupId]);

  return (
    <>
      <Box sx={{ mb: 4, fontSize: 14, color: 'rgba(114, 118, 127, 1)' }}>
        {groupDescription}
      </Box>
      <Box
        sx={{
          bg: '#56AEFF',
          color: 'white',
          p: 4,
          fontSize: 14,
          mx: -4,
          mb: -4,
        }}
      >
        <Box
          sx={{
            fontSize: 18,
            fontWeight: 600,
            mb: 3,
          }}
        >
          Improve your resume.
          <br />
          Impress recruiters.
        </Box>
        <Box sx={{ mb: 6 }}>
          Upgrade to Pro to unlock all of our suggested improvements.
        </Box>
        {shouldCreateAccount ? (
          <TUILink
            href="/v2/setup/account?fromapp=true"
            variant="secondaryButton"
            data-testid="upgrade-to-download"
            sx={linkStyles}
            onClick={() => {
              trackEvent.reviewUpsellClicked({ groupId });
            }}
          >
            View Suggestions
          </TUILink>
        ) : (
          <Link
            to="/upgrade?refLink=reviewUpsell"
            onClick={() => {
              trackEvent.reviewUpsellClicked({ groupId });
            }}
            variant="secondaryButton"
            sx={linkStyles}
          >
            View Suggestions
          </Link>
        )}
      </Box>
    </>
  );
}
